import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { HttpClient, HttpHeaders, HttpParams, HttpErrorResponse } from '@angular/common/http';
import { PlatformLocation } from '@angular/common';
import Swal from 'sweetalert2'
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PerfisAcessoService {

  perfilAcessoGet$ = new BehaviorSubject(null);
  perfilAcessoPost$ = new BehaviorSubject(null);
  perfilAcessoPut$ = new BehaviorSubject(null);
  perfilAcessoDelete$ = new BehaviorSubject(null);

  constructor(private http: HttpClient, private platformLocation: PlatformLocation) { }

  //Buscar Perfis de Acesso
  get() {
    try {
      var url: string = environment.advFirmasWebApi + '/api/' + environment.versao + "/PerfisAcessos/Obter/" + environment.empresa

      this.http.get(url).subscribe({
        next: (data) => this.perfilAcessoGet$.next(data),
        error: (error: HttpErrorResponse) => {
          if (error.status === 500) {
            Swal.fire({
              'width': 500,
              'title': 'Oops...',
              'text': error.error.detail,
              'icon': 'error'
            });
          } else {
            Swal.fire('Oops...', 'Algo deu errado, por favor entre em contato com o Suporte!', 'error');
          }
        }
      }).add(() => {
        this.perfilAcessoGet$.unsubscribe(),
          this.perfilAcessoGet$ = new BehaviorSubject(null);
      });
    } catch (e) {
      Swal.fire({
        title: "Oops...",
        text: "Algo deu errado, por favor entre em contato com o Suporte!",
        icon: "error",
        timer: 1500,
        showCancelButton: false,
        showConfirmButton: true
      });
    }
  }
}
